export function collectionsSlider() {
  const sliderWraps = $(".collection-section-slider");
  $(window).on("load", function() {
    sliderWraps.each(function () {
      let $slider = $(this);
      $slider.slick({
        infinite: false,
        slidesToScroll: 1,
        variableWidth: true,
        mobileFirst: true,
        adaptiveHeight: true,
        prevArrow: `<button class="slick-prev slick-arrow button arrow" aria-label="Prev" type="button"><svg viewBox="0 0 19 20"><path d="M18.3929 10L6.30886 15.9927L9.61622 10.001L6.30886 4.00732L18.3929 10Z"></path></svg></button>`,
        nextArrow: `<button class="slick-next slick-arrow button arrow" aria-label="Next" type="button"><svg viewBox="0 0 19 20"><path d="M18.3929 10L6.30886 15.9927L9.61622 10.001L6.30886 4.00732L18.3929 10Z"></path></svg></button>`,
        responsive: [
          {
            breakpoint: 568,
            settings: {
                adaptiveHeight: false,
            }
          },{
            breakpoint: 1800,
            settings: {
                slidesToShow: 3,
            }
          }
        ]
      });
    });
  });
}



// WEBPACK FOOTER //
// ./assets/js/modules/collections-slider.js